import {
  BlockContext,
  SlateContext,
} from '@tribeplatform/react-slate-kit/hooks'
import { SlateProps } from '@tribeplatform/react-slate-kit/types'
import { getBlockProps } from '@tribeplatform/react-slate-kit/utils'

import { useCustomizerBlockSettings } from '../hooks/index.js'
import { AddBlockEditor } from './AddBlockEditor.js'
import { EditBlockEditor } from './EditBlockEditor.js'

export const BlockEditor = ({ slateProps }: { slateProps: SlateProps }) => {
  const { blockId, action } = useCustomizerBlockSettings()

  return (
    <SlateContext.Provider value={slateProps}>
      <BlockContext.Provider value={getBlockProps(blockId, slateProps)}>
        {action === 'add' && <AddBlockEditor />}
        {action === 'edit' && <EditBlockEditor />}
      </BlockContext.Provider>
    </SlateContext.Provider>
  )
}
